const logoUrlMap = [
    {
      name: ['adobe'],
      logoUrl: 'https://tetra4d.com/wp-content/uploads/2017/02/adobe-icon.png',
    },
    {
      name: ['behance'],
      logoUrl: 'https://cdn-icons-png.flaticon.com/512/51/51916.png',
    },
    {
      name: ['ethereum', 'eth'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/6/6f/Ethereum-icon-purple.svg/langfr-220px-Ethereum-icon-purple.svg.png',
    },
    {
      name: ['facebook', 'fb'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Facebook_logo_%28square%29.png/800px-Facebook_logo_%28square%29.png',
    },
    {
      name: ['instagram', 'insta'],
      logoUrl: 'https://cdn2.iconfinder.com/data/icons/social-media-2285/512/1_Instagram_colored_svg_1-512.png',
    },
    {
      name: ['lightroom'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b6/Adobe_Photoshop_Lightroom_CC_logo.svg/1200px-Adobe_Photoshop_Lightroom_CC_logo.svg.png',
    },
    {
      name: ['linkedin'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/8/81/LinkedIn_icon.svg/800px-LinkedIn_icon.svg.png',
    },
    {
      name: ['photoshop'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/a/af/Adobe_Photoshop_CC_icon.svg/1200px-Adobe_Photoshop_CC_icon.svg.png',
    },
    {
      name: ['solona', 'sol'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/en/b/b9/Solana_logo.png',
    },
    {
      name: ['truepic'],
      logoUrl: 'https://media.licdn.com/dms/image/C4E0BAQHO4GZ5sOt5bA/company-logo_200_200/0/1679443267788/truepic_inc_logo?e=2147483647&v=beta&t=PyxgcsBcQYD2AxcGJxWBjC59apsMcFJqylP9Ba4eHcM',
    },
    {
      name: ['x', 'twitter'],
      logoUrl: 'https://upload.wikimedia.org/wikipedia/commons/thumb/b/b7/X_logo.jpg/1200px-X_logo.jpg',
    },
  ];

export const getLogoUrl = (name) => logoUrlMap.find(item => item.name.includes(name))?.logoUrl;

export const getUserNameFromUrl = (url) => url.split('/').filter(Boolean).pop();

export const getDomainName = (url) => {
  const hostname = new URL(url).hostname; // Extract the hostname, e.g., "www.behance.net"
  const domain = hostname.split('.').slice(-2, -1)[0]; // Get the second-to-last part, e.g., "behance"
  return domain.charAt(0).toUpperCase() + domain.slice(1); // Uppercase the first character
};

